// CartRelated.js
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from 'api';
import { formatPrice, debug } from 'utils';
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from "react-router-dom";
import FormalitiesTemplateItem from "components/formalities/helpers/FormalitiesTemplateItem";
import FormalityPricingDetailsModal from 'components/formalities/modals/FormalityPricingDetailsModal';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { loadCart } from '../../redux/cartSlice';
function CartRelated({ title = '', className = '' }) {
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [pricingDetails, setPricingDetails] = useState(null);
  const { t } = useTranslation();
  const getRelatedItems = async () => {
    try {
      const response = await api.get('/cart/related');
      if (response && response.data) {
        setItems(response.data);
      }

    } catch (e) {
      setItems([]);
    }
  }
  const onSelectTemplate = () => { }

  useEffect(() => {
    getRelatedItems()
  }, [user.isSignedIn]);
  return (
    <>{items.length > 0 && (
      <div className={`cart-related ${className} bg-primary-10 pt-4 pb-5 px-4 rounded-3`}>
        {title &&
          <div className="cms-block-title">
            <h2 className="">
              <span className="fw-normal px-3 text-uppercase">{title}</span>
            </h2>
          </div>
        }
        <div className="row g-4">
          {items.map((item) => (
            item.ftId &&
            <FormalitiesTemplateItem
              key={item.ftId}
              tpl={item}
              onSelect={(tpl) => {
                navigate(`/formalities/request/create/${tpl.ftId}`);
              }}
              onShowPricing={setPricingDetails}
            />
          ))}
        </div>
      </div>
    )}
      {pricingDetails && (
        <FormalityPricingDetailsModal
          pricing={pricingDetails}
          onClose={() => setPricingDetails(null)}
        />
      )}
    </>
  );
}
export default CartRelated;

